import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Auth from '../../auth';
import HeartRunnerloginContainer from '../../HeartRunnerLogin/container/heartRunnerLoginContainer';

import forgotPasswordContainer from '../../ForgotPassword/containers/forgotPasswordContainer';
import resetPasswordContainer from '../../ForgotPassword/containers/resetPasswordContainer';


import SuperAdminLoginContainer from '../../SuperAdminLogin/container/superAdminLoginContainer';
import SuperAdminDashboardLayoutComponent from '../../SuperAdminLayout/containers/superAdminDashboardLayoutContainer';
import SuperAdminLayoutComponent from '../../SuperAdminLayout/containers/superAdminLayoutContainer';
import HeartRunnerRegistrationComponent from '../../HeartRunnerRegistration/containers/registrationContainer';
import HeartRunnerLayoutComponent from '../../HeartRunner/HeartRunnerLayout/containers/heartRunnerLayoutContainer'
import viewPrivacyPolicyContainer from '../../SuperAdminSetting/container/viewPrivacyPolicyContainer';
import viewTermsOfUseContainer from '../../SuperAdminSetting/container/viewTermsOfUseContainer';

export const MainComponent = () => (
      <div>
            <Route exact path="/" component={SuperAdminLoginContainer} />
            <Route exact path="/login1" component={HeartRunnerloginContainer} />
            <Route exact path="/heartrunnerlogin" component={HeartRunnerloginContainer} />
            
            <Route exact path="/forgotpassword" component={forgotPasswordContainer} />
            <Route exact path="/resetpassword/:id" component={resetPasswordContainer} />
            
            <Route exact path="/login" component={SuperAdminLoginContainer} />
            <Route exact path="/superadmin/login" component={SuperAdminLoginContainer} />
            <Route exact path="/superadmin" component={SuperAdminLoginContainer} />
            <Route exact path="/superadmin" component={SuperAdminLoginContainer} />
            <Route exact path="/Privacy-Policy" component={viewPrivacyPolicyContainer} />
            <Route exact path="/Terms-Of-Use" component={viewTermsOfUseContainer} />
            <PrivateRoute1 exact path="/superadmin/dashboard" component={SuperAdminDashboardLayoutComponent} />

            {/* <PrivateRoute exact path="/superadmin/dashboard" component={SuperAdminDashboardLayoutComponent} allowedRoles={['Dashboard']}/> */}
            <PrivateRoute exact path="/superadmin/organisations" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/approveorganisation" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/addorganization" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/settings" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/organizationdevicelist/:id" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/addnewdevice/:id" component={SuperAdminLayoutComponent} />
            
            
            
            <PrivateRoute exact path="/organizationpendingdevicelist/:id" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/organizationadmins/:id" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/pinmanagement/:id" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/addAdmin/:id" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/IncomingAlarmFields/" component={SuperAdminLayoutComponent} />

            <PrivateRoute exact path="/superadmin/Alarmtemplates" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/Alarmtemplates/:id" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/superadmin/OrganizationAlarmtemplates/" component={SuperAdminLayoutComponent} />
            <PrivateRoute exact path="/registration" component={HeartRunnerRegistrationComponent} />
            <PrivateRoute exact path="/superadmin/FirstResponder/" component={SuperAdminLayoutComponent} allowedRoles={['First_Responders_List']}/>
            <PrivateRoute exact path="/superadmin/addFirstResponder" component={SuperAdminLayoutComponent} allowedRoles={['Add_First_Responder']}/>
            <PrivateRoute exact path="/HeartRunner/Profile" component={HeartRunnerLayoutComponent} />
            <PrivateRoute exact path="/superadmin/pendingFirstResponder" component={SuperAdminLayoutComponent} allowedRoles={['Pending_List']} />
            <PrivateRoute exact path="/superadmin/settingsFirstResponder" component={SuperAdminLayoutComponent} allowedRoles={['Settings']}/>     
            <PrivateRoute exact path="/superadmin/terms-of-use-setting" component={SuperAdminLayoutComponent} allowedRoles={['Terms_And_Conditions_Setting']}/>
            <PrivateRoute exact path="/superadmin/carousel-setting" component={SuperAdminLayoutComponent} allowedRoles={['Crousel_Settings']}/>
            <PrivateRoute exact path="/superadmin/region" component={SuperAdminLayoutComponent} allowedRoles={['Regions']}/>
             <PrivateRoute exact path="/superadmin/monthlyReport" component={SuperAdminLayoutComponent} allowedRoles={['Monthly_Report']}/>
             <PrivateRoute exact path="/superadmin/userAuthList" component={SuperAdminLayoutComponent} allowedRoles={['Authentication_Method_Setting']}/>
              <PrivateRoute exact path="/superadmin/reportsubscribers" component={SuperAdminLayoutComponent} allowedRoles={['Monthly_Report_Subscribers']} />
            <PrivateRoute exact path="/superadmin/permissions" component={SuperAdminLayoutComponent} allowedRoles={['Permissions']} />
            <PrivateRoute exact path="/superadmin/companyBranding" component={SuperAdminLayoutComponent} allowedRoles={['Company_Branding']}/>
            
            <PrivateRoute exact path="/superadmin/tetraResources" component={SuperAdminLayoutComponent} allowedRoles={['Tetra_Resources_List']}/>
            <PrivateRoute exact path="/superadmin/contact-setting" component={SuperAdminLayoutComponent} allowedRoles={['Contact_Setting']}/>
            <PrivateRoute exact path="/superadmin/email-setting" component={SuperAdminLayoutComponent} allowedRoles={['Email_Setting']}/> 
            <PrivateRoute exact path="/superadmin/addNotification" component={SuperAdminLayoutComponent} allowedRoles={['Add_New_Notification']} />
            <PrivateRoute exact path="/superadmin/detailedNotification" component={SuperAdminLayoutComponent} allowedRoles={['View_Notification']}/>
            <PrivateRoute exact path="/superadmin/alarm-rules" component={SuperAdminLayoutComponent} allowedRoles={['Alarm_Rules']} />
            <PrivateRoute exact path ="/superadmin/alarm-sound-setting" component={SuperAdminLayoutComponent} allowedRoles={['Alarm_Audio_Setting']}/>
            <PrivateRoute exact path="/superadmin/general-setting" component={SuperAdminLayoutComponent} allowedRoles={['General_Setting']} />
            <PrivateRoute exact path="/superadmin/feedback-setting" component={SuperAdminLayoutComponent} allowedRoles={['Add_Feedback_Question_Details']}/>
            <PrivateRoute exact path="/superadmin/detailedfeedback-setting" component={SuperAdminLayoutComponent} allowedRoles={['Alarm_Feedback_Questions']} />
            <PrivateRoute exact path="/superadmin/detailedfeedback-setting-for-app" component={SuperAdminLayoutComponent} allowedRoles={['Application_Feedback_Question']}/>
            <PrivateRoute exact path="/superadmin/rejectedFirstResponder" component={SuperAdminLayoutComponent} allowedRoles={['Rejected_List']} />
            <PrivateRoute exact path="/superadmin/deletedFirstResponder" component={SuperAdminLayoutComponent} allowedRoles={['Deleted_List']}/>
            <PrivateRoute exact path="/superadmin/pendingEditProfileForApproval" component={SuperAdminLayoutComponent} allowedRoles={['Profile_Pending_List_For_Approval']}/>
            <PrivateRoute exact path="/superadmin/alarmfeedbackAnswerList" component={SuperAdminLayoutComponent} allowedRoles={['Alarm_Feedback_Answers']}/>
            <PrivateRoute exact path="/superadmin/appfeedbackAnswerList" component={SuperAdminLayoutComponent} allowedRoles={['Application_Feedback_Answers']} />
            <PrivateRoute exact path="/superadmin/SMTP-setting" component={SuperAdminLayoutComponent} allowedRoles={['SMTP_Setting']}/>
            <PrivateRoute exact path="/superadmin/email-subject-setting" component={SuperAdminLayoutComponent} allowedRoles={['Email_Subject_Setting']}/>
            <PrivateRoute exact path="/superadmin/logo-setting" component={SuperAdminLayoutComponent} allowedRoles={['Logo_Setting']} />
            <PrivateRoute exact path="/superadmin/incoming-alarm-list" component={SuperAdminLayoutComponent} allowedRoles={['Incoming_Alarm_List']}/>
            <PrivateRoute exact path="/superadmin/alarm-status" component={SuperAdminLayoutComponent} allowedRoles={['Alarm_Status_Colours']} />
            <PrivateRoute exact path="/superadmin/send-profile" component={SuperAdminLayoutComponent} allowedRoles={['Alarm_Fields']} />
            <PrivateRoute exact path="/superadmin/predefined-text" component={SuperAdminLayoutComponent} allowedRoles={['Predefined_Text']} />
            <PrivateRoute exact path="/superadmin/reject-feedback-details" component={SuperAdminLayoutComponent} allowedRoles={['Reject_Feedback_Questions']} />
            <PrivateRoute exact path="/superadmin/reject-feedback-answer" component={SuperAdminLayoutComponent} allowedRoles={['Reject_Feedback_Answer']}/>
            <PrivateRoute exact path="/superadmin/FAQ-Setting" component={SuperAdminLayoutComponent} allowedRoles={['FAQ_Setting']}/>
            <PrivateRoute exact path="/superadmin/Privacy-Policy-Setting" component={SuperAdminLayoutComponent} allowedRoles={['Privacy_Policy_Settings']} />

      </div>

)
// before login
/* const PrivateRoute = ({ component: Component, ...rest }) => (
      <Route
      {...rest}
      render={props =>
      (sessionStorage.getItem('id_super_admin_token')) ? (
      <Component {...props} />
      ) : (
      <Redirect
      to={{
      pathname: "/"
      }}
      />
      )
      }
      />
); */
const PrivateRoute = ({ component: Component,allowedRoles, ...rest }) => {
     

 let arraysContainCommonValue=(arr1)=>{
 let perm=JSON.parse(sessionStorage.getItem('Permissions'));
 console.log('klk',perm)
if(perm !=null || perm!=undefined)
{
for (let perms of perm) {
     
    
    if (arr1[0]===perms.PermissionKey){
     
      return true;
    }
  }

  return false; // No common element found
}
 
}   
//

     return (<Route
      {...rest}
      render={props =>
      ((sessionStorage.getItem('id_super_admin_token')) && arraysContainCommonValue(allowedRoles)) ? (
      <Component {...props} />
      ) : (
      <Redirect
      to={{
      pathname: "/"
      }}
      />
      )
      }
      />)}
const PrivateRoute1 = ({ component: Component, ...rest }) => (
      <Route
      {...rest}
      render={props =>
      (sessionStorage.getItem('id_super_admin_token')) ? (
      <Component {...props} />
      ) : (
      <Redirect
      to={{
      pathname: "/"
      }}
      />
      )
      }
      />
);   
// after login
// const PublicRoute = ({ component: Component, ...rest }) => (
//       <Route
//       {...rest}
//       render={props =>
//       Auth.getAuth() == false ? (
//       <Redirect
//       to={{
//       pathname: "/"
//       }}
//       />
//       ) : 
//       (
//             <Component {...props} />
//       )
//       }
//       />
// );